import { render, staticRenderFns } from "./comp_ProductPage-DeliveryCalc.vue?vue&type=template&id=327ebe10&scoped=true&"
import script from "./comp_ProductPage-DeliveryCalc.vue?vue&type=script&lang=js&"
export * from "./comp_ProductPage-DeliveryCalc.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductPage-DeliveryCalc.vue?vue&type=style&index=0&id=327ebe10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327ebe10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
